<template>
  <div class="starter__video" v-if="video">
    <h1>{{ deleteItemVideo }}</h1>
      <video loop muted autoplay playsinline preload="auto" :src="video"></video>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "Video",
  data: () => ({
    video: null,
    langRoute: null
  }),
  watch: {
    '$route' (to, from) {
     this.addItemVideo()
    },
  },
  methods: {
    addItemVideo() {
          this.videoItems.map((item) => {
            this.video = item.video
          })
      },
    langRouteUpdate() {
      if (this.lang === 'lang_en') {
        this.langRoute = 'En'
      } else {
        this.langRoute = 'Ru'
      }
    }
  },
  computed: {
    ...mapGetters(['videoItems', 'lang']),
    deleteItemVideo() {
      if (this.$route.name === `Start${this.langRoute}`) {
        return this.addItemVideo()
      } if (this.$route.name !== `Start${this.langRoute}`) {
        return this.video = null
      }
    },
    add() {
      this.addItemVideo()
    },
  },
  async mounted() {
    await this.$store.dispatch('fetchVideo')
    await this.$store.dispatch('fetchLand')
    this.$nextTick(this.langRouteUpdate)
    this.$nextTick(this.addItemVideo)
  }
}
</script>